'use es6';

import Tab from 'DesignData/models/Tab';

const getReconciledTabsByIdWithRedirects = (tabsById, redirects) => {
  const tabIds = Object.keys(tabsById);
  const redirectIds = Object.keys(redirects);
  const redirectValues = Object.values(redirects);
  tabIds.forEach(tabId => {
    const redirectToId = redirects[tabId];

    if (redirectToId) {
      tabsById[redirectToId] = new Tab(Object.assign({}, tabsById[tabId], {
        id: redirectToId
      }));
      delete tabsById[tabId];
    }
  });
  redirectValues.forEach((redirectId, index) => {
    if (!tabsById[redirectId]) {
      const parentTabId = redirectIds[index];
      const parentTab = tabsById[parentTabId];
      tabsById[redirectId] = new Tab(Object.assign({}, parentTab, {
        id: redirectId
      }));
    }
  });
  return tabsById;
};

const getReconciledTabsOrderWithRedirects = (order, redirects) => {
  return order.map(tabId => {
    return redirects[tabId] || tabId;
  });
};

const getModifiedTabs = tabs => {
  const {
    lastOpen,
    activeTabId
  } = tabs;
  const tabsById = tabs.byId.asMutable();
  const tabsOrder = tabs.order.asMutable();
  const redirects = tabs.redirects.asMutable();
  const byId = getReconciledTabsByIdWithRedirects(tabsById, redirects);
  const order = getReconciledTabsOrderWithRedirects(tabsOrder, redirects);
  return {
    activeTabId: redirects[activeTabId] || activeTabId,
    byId,
    lastOpen: redirects[lastOpen] || lastOpen,
    order
  };
};

export default {
  /**
   * Helper to find nearest tab to open before closing a tab.
   *
   * @param {Array.<DesignData/models/Tab>}  tabs  List of tab models to search.
   * @param {Array.<DesignData/models/Tab>}  tabsOrder  List of tab models to search.
   * @param {(DesignData/models/Tab|Object)} _tab  Tab model to find closest neighbor; May also be an object with assetId & assetType props.
   * @return {(DesignData/models/Tab|Null)}
   */
  findNearestTab(tabs, tabsOrder, _tab, reversed = false) {
    const id = _tab.id;
    const tab = tabs[id];

    if (!tab) {
      return null;
    }

    const tabCount = tabsOrder.length;

    if (tabCount <= 1) {
      // Tab to be closed would be the only one in the list.
      return null;
    } // Find nearest tab.


    const index = tabsOrder.indexOf(id);

    if (reversed) {
      const nearestTabId = index === tabCount - 1 ? tabsOrder[index - 1] : tabsOrder[index + 1];
      return tabs[nearestTabId] || null;
    }

    const nearestTabId = index === 0 ? tabsOrder[index + 1] : tabsOrder[index - 1];
    return tabs[nearestTabId] || null;
  },

  getModifiedTabs
};